import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { Filter, Inspiration } from 'src/types/followUpInspirations';
import type { Survey } from 'src/types/survey';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

export const useInspirationsQuery = (
  survey: Survey,
  filterResult: { [key: string]: Filter },
  enabled: boolean,
) => {
  const { i18n } = useTranslation();
  const filterValues = filterResult ? Object.values(filterResult) : [];
  const endpoint = generatePath(apiPaths.FOLLOW_UP_INSPIRATIONS.INSPIRATIONS);

  return useQuery<Inspiration[]>({
    queryKey: [endpoint, filterResult, survey, i18n.language],
    enabled: enabled,
    queryFn: ({ signal }) =>
      HttpService.get(
        endpoint,
        {
          filter_ids: filterValues.map((filter) => filter.id).join(','),
        },
        true,
        { signal },
      )
        .then((response) => Promise.resolve(response.data))
        .catch(({ response: { data } }) =>
          Promise.reject(data.statusText || 'common:unknownError'),
        ),
  });
};

export default useInspirationsQuery;
